const BRIDGE_RELEASES_REPO_URL = 'https://github.com/DPSolutionsLLC/votebeats-bridge-releases';

export const BRIDGE_LATEST_RELEASE_URL = `${BRIDGE_RELEASES_REPO_URL}/releases/latest`;
export const BRIDGE_WINDOWS_INSTALLER_URL = `${BRIDGE_LATEST_RELEASE_URL}/download/VoteBeats-Bridge-Setup.exe`;
export const BRIDGE_MAC_INSTALLER_URL = `${BRIDGE_LATEST_RELEASE_URL}/download/VoteBeats-Bridge.dmg`;
